var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "college" }, [
    _vm.$route.query.isApp
      ? _c(
          "header",
          [
            _c("van-icon", {
              attrs: { name: _vm.language === "fa" ? "arrow" : "arrow-left" },
              on: { click: _vm.goAppBack }
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("300181")))])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("main", [
      _c(
        "div",
        {
          staticClass: "college_Journalism",
          on: {
            click: function($event) {
              return _vm.$router.push({
                path: "/news",
                query: {
                  isApp: _vm.$route.query.isApp,
                  language: _vm.$route.query.language
                }
              })
            }
          }
        },
        [
          _c(
            "div",
            [
              _c("b", [_vm._v(_vm._s(_vm.$t("300182")))]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n          " + _vm._s(_vm.$t("300185")) + "\n        ")
              ]),
              _vm._v(" "),
              _c("van-button", { attrs: { color: "rgba(74, 148, 248, 1)" } }, [
                _vm._v(_vm._s(_vm.$t("300089")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0)
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "max-box" }, [
        _c("div", { staticClass: "left_box" }, [
          _c(
            "div",
            {
              staticClass: "data_box",
              on: {
                click: function($event) {
                  return _vm.$router.push({
                    path: "dataPage",
                    query: {
                      isApp: _vm.$route.query.isApp,
                      language: _vm.$route.query.language
                    }
                  })
                }
              }
            },
            [
              _c(
                "div",
                [
                  _c("div", [_c("b", [_vm._v(_vm._s(_vm.$t("300183")))])]),
                  _vm._v(" "),
                  _c(
                    "van-button",
                    { attrs: { color: "rgba(239, 125, 98, 1)" } },
                    [_vm._v(_vm._s(_vm.$t("300089")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(1)
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "video_box", on: { click: _vm.tourl } }, [
            _c(
              "div",
              [
                _c("div", [_c("b", [_vm._v(_vm._s(_vm.$t("300189")))])]),
                _vm._v(" "),
                _c(
                  "van-button",
                  { attrs: { color: "rgba(240, 149, 77, 1)" } },
                  [_vm._v(_vm._s(_vm.$t("300089")))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(2)
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "study_box",
            on: {
              click: function($event) {
                return _vm.$router.push({
                  path: "/study",
                  query: {
                    isApp: _vm.$route.query.isApp,
                    language: _vm.$route.query.language
                  }
                })
              }
            }
          },
          [
            _c(
              "div",
              [
                _c("b", [_vm._v(_vm._s(_vm.$t("300184")))]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            " + _vm._s(_vm.$t("300187")) + "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "van-button",
                  { attrs: { color: "rgba(12, 170, 109, 1)" } },
                  [_vm._v(_vm._s(_vm.$t("300089")))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(3)
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "Journalism_img" }, [
      _c("img", {
        attrs: {
          src: require("../../assets/images/image_news@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          src: require("../../assets/images/image_date@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "video_img" }, [
      _c("img", {
        attrs: {
          src: require("../../assets/images/image_video@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "study_img" }, [
      _c("img", {
        attrs: {
          src: require("../../assets/images/image_study@2x.png"),
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c18bfee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c18bfee","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/college/index.vue
// module id = ArfI
// module chunks = 0